<script>
    import {replace} from 'svelte-spa-router'

	export let header_dash_token;
	export let header_mebot_id;
    export let mebots_moving;
    export let mebot_url;
    export let badge_n;
    export let news_badge_n = 0;
    export let map_badge_n = 0;
    export let is_alpha;

    export function set_section(name) {

        if (current_section == 'home' && name == 'home') {
            //window.location.reload()
            replace("/");

        } else if (name == 'map') {
            replace("/#/map/2/1");
            setCookie("city_code", ' ', 1);
            setCookie("section", name, 1)
            setCookie("map_badge_n", -1, 1);
        } else if (name == 'map42') {
            replace('/#/map42/2/1/' + header_mebot_id);
            setCookie("section", name, 1)
        } else if (name == 'news') {
            replace("/#/news/2/1");
            setCookie("news_badge_n", -1, 1);
            news_badge_n = 0;
            //setCookie("news_badge_n", 12, 1);

            //console.log('news_badge_n:' + news_badge_n);
        } else {
            setCookie("section", name, 1)
        }

        setCookie("map_lo_x", 0, 1);
        setCookie("map_lo_y", 0, 1);
        setCookie("map_zoom", 2, 1);
    }

    function stop() {
        mebots_moving = false;
    }

    function setCookie(cname, cvalue, exdays) {
		const d = new Date();
		d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
		let expires = "expires=" + d.toUTCString();
		document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
	}

    function getCookie(cname) {
        let name = cname + "=";
        let decodedCookie = decodeURIComponent(document.cookie);
        let ca = decodedCookie.split(';');
        for(let i = 0; i <ca.length; i++) {
            let c = ca[i];
            while (c.charAt(0) == ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(name) == 0) {
                return c.substring(name.length, c.length);
            }
        }
        return "";
    }

    setCookie("is_live_tracking_on", 'no', 1);

    if (header_mebot_id > 0) {
        //nothing
    } else {
        header_mebot_id = getCookie('m_id');
        console.log('got m_id from cookie:' + getCookie('m_id'));
    }

    if (!mebot_url) {
        mebot_url = getCookie('mebot_img_url');
    }

    if (!is_alpha) {
        is_alpha = getCookie('is_alpha');
    }

    if (header_dash_token == '2' || header_dash_token == '') {
        //console.log('try to get header');
        header_dash_token = getCookie('m_dash_token');
        if (header_dash_token == '' || header_dash_token == null) {
            header_dash_token = '1';
        }
    }
    //console.log('header ' + header_dash_token)

    let current_section = getCookie("section");
    //console.log('current_section: ' + current_section)

    let mebot_img_url = getCookie("mebot_img_url");
    if (map_badge_n == 0) {
        map_badge_n = getCookie("map_badge_n");
    }

    if (news_badge_n == 0) {
        news_badge_n = getCookie("news_badge_n");
    }

    //console.log(getCookie("section"));


    function alpha_mebot() {
        if (is_alpha == 1) {
            return true;
        } else {
            return false;
        }

		let m_id = header_mebot_id;
		if (m_id == 2 || m_id == 76 || m_id == 87 || m_id == 1 || m_id == 110 || m_id == 338 || m_id == 250 || m_id == 339 || m_id == 338 || m_id == 396 || m_id == 10975) {
		    return true;
		}
		return false;
	}
</script>

<menu>
{#if (header_dash_token == '1') }

<center>
    <div class="menu_row">
    <table width=300px height=20px border=0>
        <tr valign=middle>
        <td width=50px>
                <div class="button">
            <a href="https://mebots.xyz/">
            <button id=1 class="menu_btn_home menu_active" >
                <img style="user-select: none;" src='https://app.mebots.xyz/img/mebot_planet_500.png' width="30px" height="30px" alt="Mebots" />
            </button>
            </a>
                </div>
        </td>
        <td width=70px align=middle valign=middle>
        <div style="font-size: 16px;">
            <a href="/#/feed/1/1">
                <div class="button">
                <button id=5 on:click={() => set_section('news')} class="menu_btn_3" class:menu_active={ current_section == 'news' }>🗞️
                        <span class="news__badge"> 99+ </span>
                    <div class="header-text">News</div>
                </button>
                </div>
            </a>    
<!--        <a href="/#/feed/{header_dash_token}/{header_mebot_id}">
            <div class="button">

            <button id=5 on:click={() => set_section('news')} class="menu_btn_3" class:menu_active={ current_section == 'news' }>👀
                {#if badge_n > 0 }
                <span class="button__badge"> {badge_n} </span>
                {/if}
            </button>
            </div>
        </a>&nbsp;-->
        </div>
    
        <td width=180px align=right valign=middle>
        <div style="font-size: 16px;">
        <a href="/#/habitat_leaderboard/1/1/1"><button id=4 on:click={() => set_section('leaderboard')} class="menu_btn_3" class:menu_active={ current_section == 'leaderboard' }>🏆</button></a>&nbsp;&nbsp;&nbsp;&nbsp;
		<!--<a href="/#/move/{header_dash_token}/{header_mebot_id}"><button disabled id=2 on:click={() => set_section('move')} class="menu_btn_0" class:menu_active={ current_section == 'move' }>Move</button></a>&nbsp;
		<a href="/#/draw3/{header_dash_token}/{header_mebot_id}"><button disabled id=3 on:click={() => set_section('pick')} class="menu_btn_1" class:menu_active={ current_section == 'pick' }>Find</button></a>&nbsp;&nbsp;-->

        <a href="https://app.mebots.xyz/invite.html?"><button id=2 on:click={() => set_section('move')} class="menu_btn_join join-active" >&nbsp;Join!&nbsp;</button>&nbsp;&nbsp;</a>

        </div>
        </td>
        </tr>
    </table>
    </div>
</center>

{:else }

<center>
    <div class="menu_row">
    <table width=330px height=20px border=0>
        <tr valign=middle>
        <td width=50px>
            <a href="/#/dash/{header_dash_token}/{header_mebot_id}">
                <div class="button">
            <button id=1 on:click={() => set_section('home')} class="menu_btn_home" class:menu_active={ current_section == 'home' }>
                {#if mebot_url}
                <img style="user-select: none;" src={mebot_url} width="34px" height="34px" alt="My Mebot" />
                {:else }
                <img style="user-select: none;" src='https://app.mebots.xyz/img/egg-ai_500.png' width="30px" height="30px" alt="My Mebot" />
                {/if}
            </button>
                </div>
            </a>
        </td>
        <td width=250px align=right valign=middle style="white-space: nowrap;">
        <div style="font-size: 16px;">
        <a href="/#/feed/2/1">
            <div class="button">
            <button id=5 on:click={() => set_section('news')} class="menu_btn_3" class:menu_active={ current_section == 'news' } class:text-electric-location-active={ current_section == 'news' }>🗞️
                {#if news_badge_n > 0 }
                    {#if news_badge_n > 99 }
                    <span class="news__badge"> 99+ </span>
                    {:else }
                    <span class="news__badge"> {news_badge_n} </span>
                    {/if}
                {/if}
                <div class="header-text" class:header-active={ current_section == 'news'} >News</div>
            </button>
            </div>
        </a>
        <a href="/#/map/2/1">
            <button style="position: relative;" on:click={() => set_section('map')} class="menu_btn_mebots text-electric-location2" class:menu_active={ current_section == 'map' } class:text-electric-location-active={ current_section == 'map' }>
                <span style="padding-left: 2px; padding-right: 2px;">📍</span>
                {#if map_badge_n > 0}
                    {#if map_badge_n > 99 }
                    <span class="map__badge"> 99+ </span>
                    {:else }
                    <span class="map__badge"> {map_badge_n} </span>
                    {/if}
                {/if}
                <div class="header-text" class:header-active={ current_section == 'map' } >Map</div>
            </button>
        </a>&nbsp;
        <a href="/#/map42/2/1/{header_mebot_id}">
            <button style="position: relative;" on:click={() => set_section('map42')} class="menu_btn_mebots text-electric-location2" class:menu_active={ current_section == 'map42' } class:text-electric-location-active={ current_section == 'map42' }>
                <span style="padding-left: 2px; padding-right: 2px;">🌐</span>
                <div class="header-text" class:header-active={ current_section == 'map42' } >3D</div>
            </button>
        </a>&nbsp;
        <a href="/#/stage_battle/2/1"><button id=6 on:click={() => set_section('battle')} class="menu_btn_3" class:menu_active={ current_section == 'battle' } class:text-electric-location-active={ current_section == 'battle' }>⚔️</button></a>&nbsp;
        <!--<a href="/#/chat/2/1"><button id=4 on:click={() => set_section('battle')} class="menu_btn_3" class:menu_active={ current_section == 'battle' }>💬</button></a>&nbsp;-->
		<a href="/#/move/{header_dash_token}/{header_mebot_id}"><button id=2 on:click={() => set_section('move')} class="menu_btn_0" class:menu_active={ current_section == 'move' } class:text-electric-location-active={ current_section == 'move' }>Move</button></a>&nbsp;
		<!--<a href="/#/draw3/2/{header_mebot_id}"><button id=3 on:click={() => set_section('pick')} class="menu_btn_1" class:menu_active={ current_section == 'pick' } class:text-electric-location-active={ current_section == 'pick' }>Find</button></a>&nbsp;&nbsp;-->
        </div>
        </td>
        </tr>
    </table>
    </div>
</center>

{/if}

</menu>

<style>

.menu_row {
    display: flex;
    flex-wrap: wrap;
    width: 300px;
    justify-content: right;
    margin-bottom: 0px;
    margin-right: 30px;
}

.menu_btn_home {
    font-size: 24px;
    border-radius: 15px;
    border: 1px solid rgb(83, 83, 83);
    background-color: #202020;
    color: rgba(255, 255, 255, 1);
    padding: 9px 6px 3px 6px;
    box-shadow: 0 5px 15px rgba(145, 145, 145, .4);
}

.menu_btn_join {
    margin-top: 2px;
    font-size: 16px;
    border-radius: 5px;
    border: 1px solid rgb(83, 83, 83);
    background-color: #202020;
    color: rgba(255, 255, 255, 1);
    padding: 8px;
    box-shadow: 0 5px 15px rgba(145, 145, 145, .4);
}

.menu_btn_mebots {
    margin-top: 2px;
    font-size: 15px;
    border-radius: 5px;
    border: 1px solid rgb(83, 83, 83);
    background-color: #202020;
    color: rgba(255, 255, 255, 1);
    padding: 8px;
    box-shadow: 0 5px 15px rgba(145, 145, 145, .4);
}

.menu_btn_0 {
    margin-top: 2px;
    font-size: 15px;
    border-radius: 5px;
    border: 1px solid rgb(83, 83, 83);
    background-color: #202020;
    color: #1bffe8ee;
    padding: 8px;
    box-shadow: 0 5px 15px rgba(145, 145, 145, .4);
}

.menu_btn_1 {
    margin-top: 2px;
    font-size: 15px;
    border-radius: 5px;
    border: 1px solid rgb(83, 83, 83);
    background-color: #202020;
    color: #ffaf1bee;
    padding: 8px;
    box-shadow: 0 5px 15px rgba(145, 145, 145, .4);
}

.menu_btn_3 {
    margin-top: 2px;
    font-size: 16px;
    border-radius: 5px;
    border: 1px solid rgb(83, 83, 83);
    background-color: #202020;
    color: #1bffe8ee;
    padding: 8px 6px 8px 6px;
    box-shadow: 0 5px 15px rgba(145, 145, 145, .4);
}

.menu_active {
    box-shadow: 0 5px 15px #1bffe8ee;
}


    .join-active {

        background: linear-gradient(114deg, #42fff91e, #42e3ff, #42e3ff51);
	    background-size: 800% 800%;

		-webkit-animation: AnimationName 4s ease infinite;
		-moz-animation: AnimationName 4s ease infinite;
		-o-animation: AnimationName 4s ease infinite;
		animation: AnimationName 4s ease infinite;

		@-webkit-keyframes AnimationName {
			0%{background-position:0% 71%}
			50%{background-position:100% 30%}
			100%{background-position:0% 71%}
		}
	}
	@-moz-keyframes AnimationName {
		0%{background-position:0% 71%}
		50%{background-position:100% 30%}
		100%{background-position:0% 71%}
	}
	@-o-keyframes AnimationName {
		0%{background-position:0% 71%}
		50%{background-position:100% 30%}
		100%{background-position:0% 71%}
	}
	@keyframes AnimationName {
		0%{background-position:0% 71%}
		50%{background-position:100% 30%}
		100%{background-position:0% 71%}
	}

.button {
  color: white;
  display: inline-block; /* Inline elements with width and height. TL;DR they make the icon buttons stack from left-to-right instead of top-to-bottom */
  position: relative; /* All 'absolute'ly positioned elements are relative to this one */
  padding: 2px 5px; /* Add some padding so it looks nice */
}

.news__badge {
  background-color: rgb(253, 108, 12);
  border-radius: 5px;
  border: 0px solid white;
  color: white;

  padding: 2px 4px;
  font-size: 12px;

  position: absolute; /* Position the badge within the relatively positioned button */
  top: 0;
  right: 0;
}

.map__badge1 {
  background-color: rgb(253, 108, 12);
  border-radius: 5px;
  border: 0px solid white;
  color: white;

  padding: 2px 4px;
  font-size: 6px;

  position: absolute; /* Position the badge within the relatively positioned button */
  top: 0;
  right: 0;
}

.map__badge {
	background-color: #55f6ff;
	border-radius: 5px;
	border: 0px solid white;
	color: rgb(0, 0, 0);
	box-shadow: 0 0 8px rgb(0, 255, 255), 0 0 20px rgba(130, 132, 132, 0.819);

	padding: 2px 4px;
	font-size: 12px;

	position: absolute;
	top: -5px;
	right: -3px;
	z-index: 1000;
}

.text-electric-location2 {
    background: linear-gradient(129deg, #55f6ff51, #76eaff, #090033, #ff0000);
    background-size: 800% 800%;
}

.text-electric-location-active {
    background: linear-gradient(129deg, #55f6ff, #76eaff, #090033, #ff0000);
    background-size: 800% 800%;
    color: black;

/*
    -webkit-animation: AnimationName 5.8s ease infinite;
    -moz-animation: AnimationName 5.8s ease infinite;
    -o-animation: AnimationName 5.8s ease infinite;
    animation: AnimationName 5.8s ease infinite;*/
}

.header-text {
    position: relative;
    color: #55f6ff;
	font-size: 10px;
}
.header-active {
    color: black;
}

</style>
